module.exports = __webpack_public_path__ + "images/estimate_entry_banner/appeal_label_pc_539b4c051161e1a98c3f23d32ed6aa90.svg";